module.exports = __webpack_public_path__ + "img/cruise-speed.d156e18b.svg";